export function PageFooter() {
    return <div></div>
}